<template>
	<div style="width: 100%; height: 100%; padding-left: 252px">
		<v-card elevation="0" style="height: 100%">
			<v-card-title>
				视图设置<v-spacer />
				<v-btn color="green" elevation="0" dark @click="edit"> <v-icon dark>mdi-plus</v-icon>新增 </v-btn>
			</v-card-title>
			<v-toolbar flat>
				<v-btn-toggle v-model="btnValue" @change="btnGroupClick" dense group mandatory color="primary" class="ml-n2">
					<v-btn :value="bi.key" class="ml-2" v-for="(bi, index) in btnGroup" :key="index">{{ bi.val }}</v-btn>
				</v-btn-toggle>
				<v-spacer></v-spacer>
				<div style="width: 300px">
					<v-text-field @click:append="searchQuery" @keyup.enter="searchQuery" v-model="queryParam.condition" placeholder="名称/说明" append-icon="mdi-magnify" class="pt-5" outlined dense clearable></v-text-field>
				</div>
			</v-toolbar>
			<v-divider></v-divider>
			<v-card-text class="pt-0">
				<v-data-table :headers="headers" :items="desserts" disable-pagination :loading="loading" loading-text="数据加载中..." class="elevation-0" hide-default-footer>
					<template v-slot:[`item.first_col`]="{ item }">{{ desserts.indexOf(item) + 1 }}</template>
					<template v-slot:[`item.ptype`]="{ item }">{{ item.ptype | dict("ICO:图标/IMG:图片/FRM:框架/VTK:组件") }}</template>
					<template v-slot:[`item.pdeft`]="{ item }">
						<v-switch :input-value="item.pdeft == '1'" :disabled="item.pdeft == '1'" @change="state(item.id)" inset dense></v-switch>
					</template>
					<template v-slot:[`item.actions`]="{ item }">
						<a class="primary--text mr-4" @click="edit(item)">修改</a>
						<a v-if="item.pdeft != '1'" class="red--text mr-0" @click="deleteItem(item.id)">删除</a>
					</template>
				</v-data-table>
			</v-card-text>
		</v-card>
		<v-form ref="entity" v-model="valid">
			<v-dialog v-model="dialog" persistent no-click-animation scrollable max-width="520">
				<v-card>
					<v-card-title>
						<span class="title font-weight-bold">{{ entity.id ? "编辑视图" : "添加视图" }}</span>
						<v-spacer />
						<v-btn class="mx-0" icon @click="close">
							<v-icon>mdi-close</v-icon>
						</v-btn>
					</v-card-title>
					<v-card-text class="pb-0">
						<v-radio-group v-model="entity.ptype" row>
							<v-radio v-for="item in ptype" :key="item.key" :label="item.val" :value="item.key" @change="types(item.key)"></v-radio>
						</v-radio-group>
						<v-text-field v-model="entity.name" :rules="[(v) => !!v || '请输入名称']" label="名称" dense outlined></v-text-field>
						<v-textarea v-model="entity.props" :rules="[(v) => !!v || '请输入显示内容']" label="显示内容" :placeholder="props" dense outlined></v-textarea>
						<v-textarea v-model="entity.pscss" :rules="[(v) => !!v || '请输入显示样式']" label="显示样式" placeholder="输入格式为：color:red" dense outlined></v-textarea>
						<v-text-field v-model="entity.photo" label="示例图片" :rules="[(v) => !!v || '请输入示例图片']" placeholder="为空，请填写“#”" hint="为空，请填写“#”" dense outlined></v-text-field>
						<v-textarea v-model="entity.pform" label="拓展属性" :rules="[(v) => !!v || '请输入拓展属性']" placeholder="为空，请填写“{}”" hint="为空，请填写“{}”" dense outlined></v-textarea>
					</v-card-text>
					<v-divider />
					<v-card-actions>
						<v-spacer />
						<v-btn class="ml-2" text @click="close" elevation="0">取消 </v-btn>
						<v-btn color="info" text @click="submit" elevation="0">保存 </v-btn>
					</v-card-actions>
				</v-card>
			</v-dialog>
		</v-form>
	</div>
</template>
<script>
import PageMixins from "@/compositions/mixins/pagination";
import Message from "@/components/message";
import Request from "@/commons/request";
export default {
	mixins: [PageMixins],
	props: {
		appsd: {
			type: Object,
			default: null,
		},
	},
	data: () => ({
		url: { list: "/app/apps-grid/page", delete: "/app/apps-grid/delete", save: "/app/apps-grid/save" },
		headers: [
			{ text: "序号", value: "first_col", sortable: false, width: 80 },
			{ text: "名称", value: "name", sortable: false, width: 240 },
			{ text: "类型", value: "ptype", sortable: false, width: 80 },
			{ text: "属性", value: "props", sortable: false },
			{ text: "样式", value: "pscss", sortable: false },
			{ text: "默认", value: "pdeft", sortable: false, width: 80 },
			{ text: "操作", value: "actions", sortable: false, width: 120 },
		],
		btnGroup: [
			{ key: "0", val: "全部" },
			{ key: "ICO", val: "图标" },
			{ key: "IMG", val: "图片" },
			{ key: "FRM", val: "框架" },
			{ key: "VTK", val: "组件" },
		],
		btnValue: "0",
		// 弹窗
		page: { limit: 20 },
		aid: "",
		// 弹窗
		ptype: [
			{ key: "ICO", val: "图标" },
			{ key: "IMG", val: "图片" },
			{ key: "FRM", val: "框架" },
			{ key: "VTK", val: "组件" },
		],
		dialog: false,
		entity: {},
		valid: true,
		props: "", //提示语
	}),
	mounted() {
		this.gridQuery();
	},
	watch: {
		$route(to, from) {
			to.query.aid && to.query.aid != from.query.aid && this.gridQuery();
		},
	},
	methods: {
		state(id) {
			Request.postForm("/app/apps-grid/state", { id: id }).then(() => {
				this.searchQuery();
				Message.toast("默认视图设置成功！");
			});
		},
		gridQuery() {
			this.queryParam.aid = this.$route.query.aid;
			this.aid = this.$route.query.aid;
			this.searchQuery();
		},
		btnGroupClick() {
			if (this.btnValue != "0") {
				this.queryParam.ptype = this.btnValue;
			} else {
				delete this.queryParam.ptype;
			}
			this.searchQuery();
		},
		edit(record) {
			this.dialog = true;
			this.entity = {};
			this.$refs.entity.reset();
			this.entity = Object.assign({}, record);
			this.$forceUpdate(); //强制刷新
		},
		types(type) {
			switch (type) {
				case "ICO":
					this.props = "输入格式为：mdi-xxx";
					break;
				case "IMG":
					this.props = "输入格式为：https://xxx/xx.jpg";
					break;
				case "FRM":
					this.props = "输入格式为：https://xxx/xx.html";
					break;
				case "VTK":
					this.props = '{"type":"组件名称","data":"后台接口"}';
					break;
			}
		},
		submit() {
			if (this.$refs.entity.validate()) {
				this.entity.aid = this.aid;
				this.entity.pdeft ??= "0";
				this.entity.operator = this.user.citizenName;
				Request.postJson(this.url.save, this.entity).then((res) => {
					if (res.meta.success) {
						Message.toast("视图设置成功", { color: "success" });
						this.gridQuery();
						this.dialog = false;
					} else {
						Message.toast("视图设置失败", { color: "error" });
					}
				});
			}
		},
		close() {
			this.$refs.entity.reset();
			this.dialog = false;
		},
	},
};
</script>

<style></style>
